import { NumberCoercible } from '../utils/NumberCoercible';
import { NumberFormat } from './NumberFormat';

const NUMBER_FORMAT_OPTIONS = {
  style: 'decimal', // default style
  notation: 'standard', // default notation
  maximumFractionDigits: 1,
} as const;

const buildStandardNumberFormat = (locale?: string): Intl.NumberFormat => NumberFormat(locale, NUMBER_FORMAT_OPTIONS);

/**
 * A standard number formatter (long format rounded to the nearest tenth).
 *
 * @param value The number value to be formatted.
 * @param locale The locale that should be used when formatting the number.
 */
export const standardNumberFormatter = (value: NumberCoercible, locale?: string): string =>
  buildStandardNumberFormat(locale).format(value.valueOf());
